import styled, { css } from "styled-components";
import { Heading } from "@viagogo/core/ui";
import { carouselHeaderFontStyleFix } from "src/website-apps/shared/components/tm-home-fix-header-sizing/util";

const carouselContainerHeaderStyleFix = css`
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    gap: var(--carousel-header-gap, ${({ theme }) => theme.spacing(6)});
  }
`;

export const TopSubcategoriesContainer = styled.section`
  display: grid;
  grid: auto / 1fr;
  gap: var(--carousel-header-gap, ${({ theme }) => theme.spacing(4)});
  width: 100%;
  ${carouselContainerHeaderStyleFix};
`;

export const TopSubcategoriesHeading = styled(Heading)`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2em;
  color: ${({ theme }) => theme.colors.textDarker};
  margin: 0;
  @media only screen and (min-width: ${({ theme }) => theme.media.breakpoints.md}px) {
    font-size: 20px;
  }
  ${carouselHeaderFontStyleFix};
`;

export const StyledSubcategoriesContainer = styled.div`
  width: 100%;
`;
